const hidePromoLayer =()=>{
    const sitePromo=document.getElementById("site_promo");
    const arrowElement = sitePromo.getElementsByClassName("arrow")[0];
    arrowElement.classList.add("arrow_down");
    arrowElement.classList.remove("arrow_up");   
    setTimeout(function(){
        $("#site_promo").animate({"bottom":-($("#site_promo").height()-$("#site_promo .title").height())});  //making the dropdown bottom value to negative value for supporting slide effect
    },300);
    sitePromo.classList.add("closeInfo");
    sitePromo.classList.remove("openInfo")
}

const showPromoLayer = ()=>{
    const sitePromo=document.getElementById("site_promo");
    const arrowElement = sitePromo.getElementsByClassName("arrow")[0];
    arrowElement.classList.add("arrow_up");
    arrowElement.classList.remove("arrow_down");   
    $("#site_promo").animate({"bottom":"0"});
    sitePromo.classList.add("openInfo");
    sitePromo.classList.remove("closeInfo");
}

export const togglePromoLayerBasedOnDevice = () =>{
    if(window.innerWidth >= "640" && window.innerHeight >= "800"){
        showPromoLayer();
    }else{
        hidePromoLayer();
    }
}

export const hideShowPromoLayer = () => {
    const sitePromo = document.getElementById("site_promo");
      //making promo info overlay open default for desktop and tablet
    if(sitePromo.classList.contains("closeInfo")){
        showPromoLayer();   //making promo info overlay closed default for mobiles
    }else{
        hidePromoLayer();
    }
}